// 负责广告点击追踪
// iframe 相关的事件监听
// 页面可见性变化追踪
export default {
	data() {
		return {
			iframes: new Map(),
			checkInterval: null,
			visibilityChangeHandler: null,
			activeIframe: null,
			lastClickTime: new Map(),
			clickCooldown: 1000,
			lastActiveElement: null,
		}
	},

	methods: {
		initAdTracking() {
			console.log(`[AdTracking] 初始化广告追踪...`)

			this.visibilityChangeHandler = this.handleVisibilityChange.bind(this)
			document.addEventListener('visibilitychange', this.visibilityChangeHandler)

			this.watchForIframeInsertion()
			this.checkInterval = setInterval(this.checkIframeClick, 200)
		},

		watchForIframeInsertion() {
			console.log(`[AdTracking] 设置 iframe 插入观察器`)

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.tagName === 'IFRAME') {
							const adContainer = node.closest('ins.adsbygoogle')
							if (adContainer) {
								this.addIframe(node)
							}
						}
						if (node.querySelectorAll) {
							const iframes = node.querySelectorAll('iframe')
							iframes.forEach((iframe) => {
								const adContainer = iframe.closest('ins.adsbygoogle')
								if (adContainer) {
									this.addIframe(iframe)
								}
							})
						}
					})
				})
			})

			observer.observe(document.body, {
				childList: true,
				subtree: true,
			})
		},

		addIframe(iframeElement) {
			const iframeId = iframeElement.id
			if (!iframeId || this.iframes.has(iframeId)) return

			const adContainer = iframeElement.closest('ins.adsbygoogle')
			if (!adContainer) return

			const info = {
				element: iframeElement,
				adSlot: adContainer.getAttribute('data-ad-slot'),
				adPosition: adContainer.getAttribute('data-ad-position'),
				adIndex: adContainer.getAttribute('data-ad-index'),
			}

			console.log(`[AdTracking] 添加新的 iframe 监听:`, {
				id: iframeId,
				info,
			})

			this.iframes.set(iframeId, info)
		},

		checkIframeClick() {
			const activeElement = document.activeElement
			if (!activeElement || activeElement.tagName !== 'IFRAME') {
				this.lastActiveElement = null
				return
			}

			const iframeId = activeElement.id
			const iframeData = this.iframes.get(iframeId)

			if (!iframeData) return

			if (activeElement !== this.lastActiveElement) {
				const now = Date.now()
				const lastClick = this.lastClickTime.get(iframeId) || 0

				if (now - lastClick >= this.clickCooldown) {
					this.handleIframeClick(activeElement, iframeData)
					this.lastClickTime.set(iframeId, now)
					this.activeIframe = { element: activeElement, ...iframeData }
				}

				this.lastActiveElement = activeElement
			}

			setTimeout(() => {
				if (document.activeElement !== activeElement) {
					this.lastActiveElement = null
				}
			}, 100)
		},

		handleIframeClick(iframeElement, iframeData) {
			console.log(`[AdTracking] 检测到 iframe 点击!`, iframeElement)
			const adContainer = iframeElement.closest('ins.adsbygoogle')

			if (adContainer) {
				const insRect = adContainer.getBoundingClientRect()
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop

				const transformData = {
					insX: insRect.left,
					insY: insRect.top + scrollTop,
					insHeight: insRect.height,
					windowWidth: window.innerWidth,
					windowHeight: window.innerHeight,
					scrollTop,
				}
				console.log(`上报客户端的数据: `, transformData)

				this.$eventrack?.('ad_click', 'click', {
					position: iframeData.adPosition,
					index: iframeData.adIndex,
					slot: iframeData.adSlot,
					transformData: JSON.stringify(transformData),
					id: iframeElement.id,
					timestamp: new Date().toISOString(),
					clickCount: (this.lastClickTime.get(iframeElement.id) || 0) + 1,
				})

				this.ttTrack(adContainer.dataset.adSlot, 'click', 'ad_iframe_click')

				if (this.$adClick) {
					this.$adClick(JSON.stringify(transformData))
				}
			}
		},
		ttTrack(id, type = 'expose', name = 'ad') {
			console.log('track')
			// const eventName = this.$store.state.hostInject?.ttEvent || 'ClickButton'
			// if (eventName) {
			//   ttq.track(eventName);
			// } else {
			//   ttq.track('ClickButton');
			// }
			// ttq.track('ClickButton')
			ttq.track('ClickButton', {
				value: '100', // number. Value of the order or items sold. Example: 100.
				currency: 'USD', // string. The 4217 currency code. Example: "USD".
				contents: [
					{
						content_id: id, // string. ID of the product. Example: "1077218".
						content_type: type, // string. Either product or product_group.
						content_name: name, // string. The name of the page or product. Example: "shirt".
					},
				],
			})
		},

		handleVisibilityChange() {
			if (document.visibilityState === 'visible') {
				const adIframes = document.querySelectorAll('ins.adsbygoogle iframe')
				adIframes.forEach((iframe) => this.addIframe(iframe))
			}
		},

		beforeDestroy() {
			if (this.checkInterval) {
				clearInterval(this.checkInterval)
			}

			if (this.visibilityChangeHandler) {
				document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
			}

			this.iframes.clear()
			this.lastClickTime.clear()
			this.lastActiveElement = null
		},
	},
}
